import { request } from '../request'
import { Plan } from '../types'

export class PlansService {

  getPlans(): Promise<Plan> {
    return request.get('/api/plans.json')
  }

}
